@if (safeVideoUrl) {
  <section class="video-container" data-testid="video-wrapper" [class.closed]="closed()">
    @if (safeDescription) {
      <p class="description" data-testid="video-description" [innerHtml]="safeDescription"></p>
      <div class="video-wrapper" (click)="onVideoClick()">
        <iframe
          title="preview fix video"
          frameborder="0"
          data-testid="video-iframe"
          allowfullscreen="true"
          [src]="safeVideoUrl"
          (load)="onVideoLoaded()"
        ></iframe>
      </div>
    }
  </section>
}
